module.exports = __webpack_public_path__ + "static/media/stars-less-768.956e2171.jpg";